<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 xl:1/2 mb-base">
                <ReferralCard @update="getPage" />
            </div>
        </div>
        <h2 class="mt-2 mb-2">Referral History</h2>
        <div id="data-list-list-view" class="data-list-container" v-if="logs">
            <ReferralTable
                :data="logs"
                :itemsPerPage="itemsPerPage"
                @itemsPerPage="setItemsPerPage"
                @search="search"
                @filter="setFilter"
                @deleteSingle="deleteConfirm"
                @edit="setEdit"
            ></ReferralTable>
            <div class="paginator-container">
                <vs-pagination
                    description
                    goto
                    descriptionTitle="Logs"
                    :sizeArray="logs.count"
                    :description-items="descriptionItems"
                    :total="logs.number_of_pages"
                    :max-items="itemsPerPage"
                    :max="itemsPerPage"
                    v-model="pageNumberComputed"
                    @changeMaxItems="setItemsPerPage"
                ></vs-pagination>
            </div>
        </div>
        <EditReferModal
            :show-data="show.editModal"
            :log-data="selectedLog"
            @close="closeEditModal"
            @update="getPage"
        />
    </div>
</template>

<script>
import EditReferModal from './EditReferModal'
import ReferralCard from '@/views/main/Refer/Cards/ReferralCard'
import ReferralTable from './Table'
import { http } from '@/services'

export default {
    name: 'Referral',
    components: {
        EditReferModal,
        ReferralTable,
        ReferralCard,
    },
    created() {
        if (this.$route.params.page)
            this.pageNumber = Number(this.$route.params.page)
        this.getPage()
    },
    beforeRouteUpdate(to, from, next) {
        next()
        if (this.$route.params.page)
            this.pageNumber = Number(this.$route.params.page)
        this.getPage()
    },
    watch: {
        pageNumber(newValue, oldValue) {
            if (Number(newValue) !== Number(oldValue))
                this.$router.push({
                    name: 'sendSingle',
                    params: { page: Number(newValue) },
                })
        },
    },
    computed: {
        pageNumberComputed: {
            set(value) {
                this.pageNumber = value
                this.getPage()
            },
            get() {
                return this.pageNumber
            },
        },
    },
    data() {
        return {
            logs: null,
            pageNumber: 1,
            itemsPerPage: 5,
            selected: null,
            queriedItems: 20,
            searchQuery: null,
            filter: 'all',
            descriptionItems: [5, 10, 20],
            selectedLog: null,
            show: {
                editModal: false,
                info1: true,
            },
        }
    },
    methods: {
        setItemsPerPage(value) {
            this.itemsPerPage = this.descriptionItems[value]
            this.getPage()
        },
        setPageNumber(value) {
            this.pageNumber = value
            this.getPage()
        },
        setView(value) {
            this.searchQuery = null
            this.view = value
            this.getPage()
        },
        getPage() {
            http.get('legal_referral', {
                params: {
                    filter: this.filter,
                    items_per_page: this.itemsPerPage,
                    page_number: this.pageNumber,
                    query: this.searchQuery,
                    view: this.view,
                },
            })
                .then((response) => {
                    this.logs = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        search(value) {
            this.searchQuery = value
            this.getPage()
        },
        setFilter(value) {
            this.filter = value
            this.getPage()
        },
        deleteConfirm(log) {
            this.selectedLog = log
            this.$vs.dialog({
                type: 'confirm',
                color: 'secondary',
                title: `Delete Advice Request`,
                text: `${this.selectedLog.client_name}`,
                accept: this.deleteLog,
                acceptText: 'Delete',
            })
        },
        deleteLog() {
            http.delete('legal_referral', {
                params: { id: this.selectedLog.id },
            })
                .then((response) => {
                    this.$vs.notify({
                        title: 'Success',
                        text: 'Advice Request Deleted',
                        color: 'success',
                        icon: 'feather',
                        iconPack: 'icon-trash',
                        position: 'top-center',
                    })
                    this.getPage()
                    this.selectedCode = null
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: 'Error',
                        text: error.response.data,
                        color: 'warning',
                        icon: 'feather',
                        iconPack: 'icon-trash',
                        position: 'top-center',
                    })
                    this.selectedCode = null
                })
        },
        setEdit(value) {
            this.selectedLog = value
            this.show.editModal = true
        },
        closeEditModal() {
            this.show.editModal = false
            this.selectedLog = null
        },
    },
}
</script>
